module.exports = __webpack_public_path__ + "media/images/players/SAMOOJA_KALLE-97292407a7cf016d9c0f45c266f19af0.png";